/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AppStringLocalizationExtended model module.
 * @module model/AppStringLocalizationExtended
 * @version V1
 */
class AppStringLocalizationExtended {
    /**
     * Constructs a new <code>AppStringLocalizationExtended</code>.
     * @alias module:model/AppStringLocalizationExtended
     */
    constructor() { 
        
        AppStringLocalizationExtended.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AppStringLocalizationExtended</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AppStringLocalizationExtended} obj Optional instance to populate.
     * @return {module:model/AppStringLocalizationExtended} The populated <code>AppStringLocalizationExtended</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AppStringLocalizationExtended();

            if (data.hasOwnProperty('group')) {
                obj['group'] = ApiClient.convertToType(data['group'], 'String');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'String');
            }
            if (data.hasOwnProperty('language')) {
                obj['language'] = ApiClient.convertToType(data['language'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AppStringLocalizationExtended</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AppStringLocalizationExtended</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['group'] && !(typeof data['group'] === 'string' || data['group'] instanceof String)) {
            throw new Error("Expected the field `group` to be a primitive type in the JSON string but got " + data['group']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }
        // ensure the json data is a string
        if (data['value'] && !(typeof data['value'] === 'string' || data['value'] instanceof String)) {
            throw new Error("Expected the field `value` to be a primitive type in the JSON string but got " + data['value']);
        }
        // ensure the json data is a string
        if (data['language'] && !(typeof data['language'] === 'string' || data['language'] instanceof String)) {
            throw new Error("Expected the field `language` to be a primitive type in the JSON string but got " + data['language']);
        }

        return true;
    }


}



/**
 * @member {String} group
 */
AppStringLocalizationExtended.prototype['group'] = undefined;

/**
 * @member {String} key
 */
AppStringLocalizationExtended.prototype['key'] = undefined;

/**
 * @member {String} value
 */
AppStringLocalizationExtended.prototype['value'] = undefined;

/**
 * @member {String} language
 */
AppStringLocalizationExtended.prototype['language'] = undefined;






export default AppStringLocalizationExtended;

